import BaseComponent from "../components/BaseComponent";
import {Div} from "@vkontakte/vkui";
import React from "react";
import PhotoStorageList from "../utils/PhotoStorageList";

class PhotoStorageFragment extends BaseComponent{


    render() {
        return <Div>
            <PhotoStorageList/>
        </Div>
    }

}

export default PhotoStorageFragment